import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchPlanscreate } from '../api/plan';
import './PlanRegistar.css';

export default function PlanCreate() {
  const [name, setName] = useState('');
  const [amount, setAmount] = useState('');
  const [planType, setPlanType] = useState('premium');
  const [interval, setInterval] = useState('one_time');
  const [trialDays, setTrialDays] = useState(0);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { companyId } = useParams();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const payload = {
        company_id: companyId,
        name,
        amount: parseInt(amount),
        plan_type: planType,
        interval,
        trial_days: interval === 'month' ? parseInt(trialDays) : 0,
      };

      await fetchPlanscreate(payload);

      setMessage('プランを登録しました！');
      setName('');
      setAmount('');
      setPlanType('premium');
      setInterval('one_time');
      setTrialDays(0);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'プラン登録に失敗しました');
    }
  };

  return (
    <div className="planRegistarBody">
      <h2 className="planRegisterTitle">プラン作成</h2>

      {message && <div style={{ color: 'green' }}>{message}</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}

      <div className="planElement">
        <div>
          <label>プラン名</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div>
          <label>金額（円）</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
          />
        </div>

        <div>
          <label>課金タイプ</label>
          <select
            value={interval}
            onChange={(e) => setInterval(e.target.value)}
          >
            <option value="one_time">一括払い</option>
            <option value="month">サブスクリプション</option>
          </select>
        </div>

        {interval === 'month' && (
          <div>
            <label>無料トライアル日数</label>
            <input
              type="number"
              value={trialDays}
              onChange={(e) => setTrialDays(e.target.value)}
              min={0}
            />
          </div>
        )}

        <div className="planRegisterButtons">
          <button
            className="registrationButton"
            type="submit"
            onClick={handleSubmit}
          >
            登録
          </button>
          <button
            type="button"
            className="backButton"
            onClick={() => navigate('/implpage')}
          >
            企業ポータルに戻る
          </button>
        </div>
      </div>
    </div>
  );
}
